import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import Constant from "../Constant";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faTrophy } from "@fortawesome/free-solid-svg-icons";
import "../../css/style.css";
import $ from "jquery";
import { getAccessToken } from "../../hooks/AccessToken";
import EditResult from "./EditResult";
import { toast } from "react-toastify";

class DataManagement extends Component {
  state = {
    ERROR: true,
    DataList: [],
    isLoading: true,
    // default filter is "all" to show all contests initially
    selectValue: "all",
    length: "",
    pageNo: "",
    defaultPageNo: 1,
    searchKey: "",
    sortByAttribute: 1,
    showStatusDialog: false,
    selectedContestId: null,
    selectedContestStatus: null,
    showResultDialog: false,
    selectedContestForResult: null,
    selectedContestResultArray: [],
    selectedContest: null,
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  // Show confirmation dialog
  showStatusConfirmation = (id, status) => {
    this.setState({
      showStatusDialog: true,
      selectedContestId: id,
      selectedContestStatus: status,
    });
  };

  // Hide confirmation dialog
  hideStatusConfirmation = () => {
    this.setState({
      showStatusDialog: false,
      selectedContestId: null,
      selectedContestStatus: null,
    });
  };

  showResultDialog = (contestId, resultArray, contest) => {
    console.log("Selected Contest Details:", {
      id: contestId,
      resultArray,
      contest,
      isLanguageBased: contest?.languageBasedModel || false,
      languages: contest?.languages || [],
      winnersPerLanguage: contest?.winnersPerLanguage || 1,
      totalNumberOfWinners: contest?.totalNumberOfWinners || 0,
    });
    this.setState({
      showResultDialog: true,
      selectedContestForResult: contestId,
      selectedContestResultArray: resultArray || [],
      selectedContest: contest,
    });
  };

  hideResultDialog = () => {
    this.setState({
      showResultDialog: false,
      selectedContestForResult: null,
      selectedContestResultArray: [],
    });
  };

  handleResultUpdated = (updatedResultArray) => {
    // Refresh the data after updating results
    this.handleSubmit(this.state.defaultPageNo);
  };

  showNotification = (message, type = "success") => {
    if (type === "error") {
      toast.error(message);
    } else {
      toast.success(message);
    }
  };

  //----------------------------------Change status-----------------------------------------------\\
  changeStatus = async (id, status) => {
    try {
      let token = getAccessToken();
      const response = await Axios.patch(
        Constant.apiBasePath + "contest/changeStatus/" + id,
        { status: status },
        { headers: { token: token } }
      );
      let { data } = response;
      if (data.status === Constant.statusSuccess) {
        toast.success(data.message);
        this.handleSubmit(this.state.defaultPageNo);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.log(err);
    }
    this.hideStatusConfirmation();
  };

  //------------------------------------Integrate API for remove contest-------------------------------//
  delete = async (contestId) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        Constant.apiBasePath + "contest/" + contestId,
        { headers: { token: token } }
      );
      let data = response.data;
      if (data.status === Constant.statusSuccess) {
        toast.success(data.message);
        this.handleSubmit(this.state.defaultPageNo);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //----------------------------------Integrate API for update contest-------------------------------\\
  update = async (contestId) => {
    try {
      this.props.history.push("/update-contest/" + contestId);
    } catch (err) {
      console.log(err);
    }
  };

  //----------------------------------Integrate API for show contests----------------------------------\\
  handleSubmit = async (pageNo, sort, filterValue) => {
    this.setState({ isLoading: true });
    try {
      let token = getAccessToken();
      // Use the state value instead of jQuery to get the filter value.
      let selectValue =
        typeof filterValue !== "undefined" ? filterValue : this.state.selectValue;
      let searchKey = this.state.searchKey;
      let sortByAttribute = this.state.sortByAttribute;
      if (sort) {
        this.setState({ sortByAttribute: sort });
        sortByAttribute = sort;
      }
      // Sending the current selectValue as "key" to API.
      // (When key is "all", the backend should return all contests.)
      const response = await Axios.post(
        Constant.apiBasePath + "contest/get-all",
        {
          key: selectValue,
          pageNo: pageNo,
          searchKey: searchKey,
          sortByAttribute: sortByAttribute,
        },
        { headers: { token: token } }
      );
      const { data, length, pageNo: currentPage } = response.data;

      // Fetch participant counts for each contest
      const updatedData = await Promise.all(
        data.map(async (contest) => {
          const participantsResponse = await Axios.get(
            `https://api.storytent.in/api/contest/getParticipantsCount/${contest._id}`,
            { headers: { token: token } }
          );
          return {
            ...contest,
            participantCount:
              participantsResponse.data.poemCount > 0
                ? participantsResponse.data.poemCount
                : participantsResponse.data.storyCount || 0,
          };
        })
      );

      this.setState({
        DataList: updatedData,
        length: length,
        pageNo: currentPage,
        defaultPageNo: pageNo,
        // Optional: you may want to clear searchKey here if needed.
        searchKey: "",
        ERROR: false,
      });
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  componentDidMount() {
    // Initially fetch all contests.
    this.handleSubmit(this.state.defaultPageNo);
  }

  render() {
    const {
      DataList,
      isLoading,
      length,
      pageNo,
      showStatusDialog,
      selectedContestId,
      selectedContestStatus,
      showResultDialog,
      selectedContestForResult,
      selectedContestResultArray,
      selectedContest,
    } = this.state;

    let bodyData = "";
    if (!isLoading && DataList.length > 0) {
      bodyData = DataList.map((el) => {
        let statusText = el.status === 1 ? "ACTIVE" : "INACTIVE";

        const requirementItems = [];
        if (el.mobileNumber) requirementItems.push("Mobile");
        if (el.idCard) requirementItems.push("ID Card");
        if (el.cityName) requirementItems.push("City");
        if (el.collegeName) requirementItems.push("College");
        if (el.collegeAddress) requirementItems.push("College Address");
        if (el.refId) requirementItems.push("Ref ID");
        if (el.durationRequired) requirementItems.push("Duration");

        const winnerNames = [];
        if (Array.isArray(el.resultArray)) {
          el.resultArray.forEach((winner) => {
            if (winner) {
              winnerNames.push(winner.name || winner.userId || winner);
            }
          });
        } else if (el.resultArray && typeof el.resultArray === "object") {
          Object.values(el.resultArray).forEach((winners) => {
            if (Array.isArray(winners)) {
              winners.forEach((winner) => {
                if (winner) {
                  winnerNames.push(winner.name || winner.userId || "N/A");
                }
              });
            }
          });
        }

        const topWinners = winnerNames.slice(0, 3);
        const winnersSummary =
          winnerNames.length > 0
            ? `${topWinners[0]}${winnerNames.length > 1 ? ` + ${winnerNames.length - 1} more` : ""}`
            : "Winners not announced";

        return (
          <tr key={el._id} className="contest-table-row">
            <td className="contest-details-col">
              <Link to={`contest-management/${el._id}`} className="contest-details-link">
                <img
                  src={el.image}
                  alt="contest"
                  className="contest-thumb"
                  resizemode="contain"
                />
                <div className="contest-details-meta">
                  <div className="contest-name">{el.name}</div>
                  <div className="contest-language-list">
                    {Array.isArray(el.languages) && el.languages.length > 0
                      ? el.languages.map((lang) => (
                          <span className="contest-language-pill" key={`${el._id}-${lang}`}>
                            {lang}
                          </span>
                        ))
                      : <span className="contest-language-pill">N/A</span>}
                    {requirementItems.length > 0 && (
                      <span className="contest-hover-anchor contest-requirement-anchor">
                        <span className="contest-req-link">Reqs ({requirementItems.length})</span>
                        <div className="contest-hover-card contest-requirements-popover">
                          <div className="popover-title">Requirements:</div>
                          <ul>
                            {requirementItems.slice(0, 6).map((item) => (
                              <li key={`${el._id}-${item}`}>
                                <span className="req-check">✓</span> {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            </td>
            <td className="contest-timeline-col">
              <div className="timeline-item">
                <span>START</span>
                <strong>{el.startDate || "-"}</strong>
              </div>
              <div className="timeline-item">
                <span>CLOSE</span>
                <strong className="timeline-close">{el.closureDate || "-"}</strong>
              </div>
              <div className="timeline-item">
                <span>RES.</span>
                <strong className="timeline-result">{el.resultDate || "Pending..."}</strong>
              </div>
            </td>
            <td className="contest-stats-col">
              <div className="contest-stats-value">{el.participantCount || 0}</div>
              <div className="contest-stats-label">ENTRIES</div>
            </td>
            <td className="contest-status-col">
              <button
                className={`contest-status-pill ${el.status === 1 ? "is-active" : "is-inactive"}`}
                onClick={() => this.showStatusConfirmation(el._id, el.status)}
              >
                {statusText}
              </button>
            </td>
            <td className="contest-winners-col">
              <div className="contest-winners-content">
                {winnerNames.length > 0 ? (
                  <div className="contest-hover-anchor contest-winners-anchor">
                    <div className="contest-winners-summary">
                      <FontAwesomeIcon icon={faTrophy} className="winner-trophy" />
                      <span>{winnersSummary}</span>
                    </div>
                    <div className="contest-hover-card contest-winners-popover">
                      <div className="popover-title">Top 3 Winners:</div>
                      <ol>
                        {topWinners.map((winner, idx) => (
                          <li key={`${el._id}-winner-${idx}`}>{winner}</li>
                        ))}
                      </ol>
                    </div>
                  </div>
                ) : (
                  <div className="contest-no-winners">Winners not announced</div>
                )}
                <button
                  className={`contest-winner-action ${winnerNames.length > 0 ? "has-result" : "no-result"}`}
                  onClick={() =>
                    this.showResultDialog(el._id, el.resultArray, el)
                  }
                >
                  {winnerNames.length > 0 ? "MANAGE WINNERS" : "SET WINNERS"}
                </button>
              </div>
            </td>
            <td className="contest-actions-col">
              <button
                className="contest-icon-btn"
                type="button"
                aria-label="Edit contest"
                onClick={() => this.update(el._id)}
              >
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ fontSize: "13px" }}
                />
              </button>
              <button
                className="contest-icon-btn danger"
                type="button"
                aria-label="Delete contest"
                onClick={() => {
                  if (window.confirm("Delete the Contest?")) {
                    this.delete(el._id);
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  style={{ fontSize: "13px" }}
                />
              </button>
            </td>
          </tr>
        );
      });
    }

    const currentPage = Number(pageNo) > 0 ? Number(pageNo) : 1;
    const totalPages =
      Number(length) > 0 ? Number(length) : DataList.length > 0 ? 1 : 0;
    const previous = Math.max(currentPage - 1, 1);
    const next = totalPages > 0 ? Math.min(currentPage + 1, totalPages) : 1;
    // Removed jQuery-based change events for #searchKey and #selectValue
    // in favor of controlled components.

    return (
      <div className="content-page contest-management-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Contest Management</h4>
                <p className="header-subtitle">
                  Manage schedules, participants, and winners.
                </p>
              </div>
              <Link to="/add-contest">
                <button
                  type="button"
                  className="btn btn-primary btn-add-event contest-add-match"
                >
                  + Add New Contest
                </button>
              </Link>
            </div>
          </div>

          <div className="event-management-body">
            <div className="card contest-management-card">
              <div className="card-body">
                <div className="filter-section">
                  <div className="filter-group">
                    <select
                      id="selectValue"
                      value={this.state.selectValue}
                      onChange={(e) => {
                        const nextFilterValue = e.target.value;
                        this.setState({ selectValue: nextFilterValue }, () => {
                          this.handleSubmit(1, undefined, nextFilterValue);
                        });
                      }}
                      className="form-control filter-select"
                    >
                      <option value="all">All Contests</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </div>

                <div className="table-wrapper contest-table-responsive">
                  <table
                    id="complex-header-datatable"
                    className="table event-table contest-management-table"
                  >
                      <thead>
                        <tr>
                          <th>Contest Details</th>
                          <th>Timeline Schedule</th>
                          <th>Stats</th>
                          <th>Status</th>
                          <th>Winners Preview</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colSpan="6" className="table-loading-cell">
                              <span className="table-loading-spinner"></span>
                              Loading contests...
                            </td>
                          </tr>
                        ) : DataList.length > 0 ? (
                          bodyData
                        ) : (
                          <tr>
                            <td colSpan="6" className="table-loading-cell">
                              No contests found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  {!isLoading && DataList.length > 0 && totalPages > 0 && (
                    <div className="pagination">
                      {currentPage <= 1 ? (
                        <button type="button" className="disabled">Previous</button>
                      ) : (
                        <button
                          type="button"
                          className="paginate-link"
                          onClick={() => this.handleSubmit(previous)}
                        >
                          Previous
                        </button>
                      )}

                      <button type="button" className="page-number">{currentPage} / {totalPages}</button>
                      {currentPage >= totalPages ? (
                        <button type="button" className="disabled">Next</button>
                      ) : (
                        <button
                          type="button"
                          className="paginate-link active"
                          onClick={() => this.handleSubmit(next)}
                        >
                          Next
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {showStatusDialog && (
            <div className="custom-modal">
              <div
                className="modal-overlay"
                onClick={this.hideStatusConfirmation}
              ></div>
              <div className="modal-container">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="modal-header"
                >
                  <h3 style={{ textAlign: "center" }}>Change Contest Status</h3>
                </div>
                <div className="modal-body">
                  <p style={{ textAlign: "center" }}>
                    Are you sure you want to make this contest{" "}
                    {selectedContestStatus === 1 ? "inactive" : "active"}?
                  </p>
                </div>
                <div
                  className="modal-footer"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <button
                    className="btn btn-secondary"
                    onClick={this.hideStatusConfirmation}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      this.changeStatus(
                        selectedContestId,
                        selectedContestStatus === 1 ? 1 : 0
                      )
                    }
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          )}
          {showResultDialog && (
            <EditResult
              open={showResultDialog}
              onClose={this.hideResultDialog}
              contestId={selectedContestForResult}
              resultArray={selectedContestResultArray}
              judgeResult={selectedContest?.judgeResult || []}
              onResultUpdated={this.handleResultUpdated}
              showNotification={this.showNotification}
              totalNumberOfWinners={selectedContest?.totalNumberOfWinners || 0}
              isLanguageBased={selectedContest?.languageBasedModel || false}
              languages={selectedContest?.languages || []}
              winnersPerLanguage={selectedContest?.winnersPerLanguage || 1}
              resultTitle={selectedContest?.resultTitle || ""}
              judgeResultTitle={selectedContest?.judgeResultTitle || ""}
              displayResult={selectedContest?.displayResult ?? 0}
              resultImage={selectedContest?.resultImage || null}
            />

          )}
          <style>{`
            .custom-modal {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1050;
            }
            .modal-overlay {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: rgba(0, 0, 0, 0.5);
              z-index: 1051;
            }
            .modal-container {
              background: white;
              border-radius: 4px;
              width: 90%;
              max-width: 500px;
              position: relative;
              z-index: 1052;
              box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            }
            .modal-header {
              padding: 15px 20px;
              border-bottom: 1px solid #eee;
            }
            .modal-header h3 {
              margin: 0;
              font-size: 18px;
            }
            .modal-body {
              padding: 20px;
            }
            .modal-footer {
              padding: 15px 20px;
              border-top: 1px solid #eee;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            }
            .btn-secondary {
              background: #6c757d;
              color: white;
              border: none;
              padding: 8px 16px;
              border-radius: 4px;
              cursor: pointer;
            }
            .btn-secondary:hover {
              background: #5a6268;
            }
            .btn-primary {
              background: #007bff;
              color: white;
              border: none;
              padding: 8px 16px;
              border-radius: 4px;
              cursor: pointer;
            }
            .btn-primary:hover {
              background: #0056b3;
            }
          `}</style>
        </div>
      </div>
    );
  }
}

export default DataManagement;
